import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import { PaymentRequestOnlineAttemptDataService } from './paymentRequestOnlineAttemptData.service';
import { PaymentRequestOnlineAttemptModel } from '../../../api/entity/paymentRequestOnlineAttempt.model';
import {
    PaymentRequestOnlineAttemptConverter
} from "../../../api/entity/converter/paymentRequestOnlineAttempt.converter";

@Injectable({
    providedIn: 'root'
})
export class PaymentRequestOnlineAttemptDataServiceAdapter extends AbstractDataServiceDtoAdapter<PaymentRequestOnlineAttemptModel, PaymentRequestOnlineAttemptConverter> {
    constructor(dataService: PaymentRequestOnlineAttemptDataService, converter: PaymentRequestOnlineAttemptConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentRequestOnlineAttemptModel {
        return new PaymentRequestOnlineAttemptModel();
    }
}
